import { useEffect, useState } from "react";
// import axios from "axios";
import { useNavigate, useLocation } from "react-router";
import axios from "axios";
// @mui
import { alpha } from "@mui/material/styles";
import {
  Box,
  Divider,
  Typography,
  Stack,
  MenuItem,
  Avatar,
} from "@mui/material";
// components
import MenuPopover from "../../../components/MenuPopover";
import { IconButtonAnimate } from "../../../components/animate";
import useDetails from "src/hooks/useDetails";
// ----------------------------------------------------------------------

const MENU_OPTIONS = [
  {
    label: "Home",
    linkTo: "../",
  },
  // {
  //   label: "Profile",
  //   linkTo: "/",
  // },
  // {
  //   label: "Settings",
  //   linkTo: "/",
  // },
];

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const [open, setOpen] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const userDetails = useDetails();
  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const userdata = {
    user_id: userDetails?.user_id,
  };
  // console.log(userdata)
  const handleClose = () => {
    setOpen(null);
  };

  const handleLogout = () => {
    axios
      // .post("https://ehr.kaizendigital.ai/api/dev1/2222/logout", userdata)
      .post("https://ehr.kaizendigital.ai/api/dev2/logout", userdata, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.data.response === "success") {
          sessionStorage.clear();
          navigate("/login");
        }
      })
      .catch((err) => {
        console.log("");
      });
  };

  return (
    <>
      <IconButtonAnimate
        onClick={handleOpen}
        sx={{
          p: 0,
          ...(open && {
            "&:before": {
              zIndex: 1,
              content: "''",
              width: "100%",
              height: "100%",
              borderRadius: "50%",
              position: "absolute",
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >
        <Avatar
          src={`https://ehr.kaizendigital.ai/api/dev2/${userDetails?.picture}`}
          alt={userDetails.firstname}
        />
      </IconButtonAnimate>

      <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        sx={{
          p: 0,
          mt: 1.5,
          ml: 0.75,
          "& .MuiMenuItem-root": {
            typography: "body2",
            borderRadius: 0.75,
          },
        }}
      >
        <Box sx={{ my: 2.5, px: 1.5 }}>
          <Typography variant="subtitle2" noWrap>
            Kaizen Zenith
          </Typography>
          <Typography variant="body2" sx={{ color: "text.secondary" }} noWrap>
            {userDetails?.username}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: "dashed" }} />

        <Stack sx={{ p: 1 }}>
          {MENU_OPTIONS.map((option) => (
            <MenuItem
              key={option.label}
              to={option.linkTo}
              onClick={handleClose}
            >
              {option.label}
            </MenuItem>
          ))}
        </Stack>

        <Divider sx={{ borderStyle: "dashed" }} />

        <MenuItem sx={{ m: 1 }} onClick={handleLogout}>
          Logout
        </MenuItem>
      </MenuPopover>
    </>
  );
}
